import { Box, Grid, Typography, Backdrop, CircularProgress } from '@mui/material';
import AppHeader from '@/components/Elements/Header/AppHeader';
import React, { useEffect, useState } from 'react';
import { gettoken, getUserInfo, getInterview, getWallet, getIsMynumberAuth } from '../constants/Api';
import { NotFound } from '@/components/Pages/Errors/NotFound';
import { useNavigate } from 'react-router';
import { CookieStorage } from 'aws-amplify/utils';
import { LongLoading } from '@/components/Elements/Loading/LongLoading';
import { amplifyClient } from '@/lib/amplifyClient';
import { getPatient } from '@/graphql/queries';
import { fetchAuthSession } from 'aws-amplify/auth';
import { executeQuery } from '@/client/graphql';
import { GetPatientQuery } from '@/API';

const client = amplifyClient();

export const Success = () => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [notFetch, setNotFetch] = useState<boolean>(false);
  const navigate = useNavigate();
  let walletFlag = false;

  useEffect(() => {
    setIsLoading(true);
    const onetime = setTimeout(async () => {
      const cookie = new CookieStorage();
      const redirectPath = await cookie.getItem('mynumber_redirect_path');
      try {
        // すでにウォレットを作成済みかどうかを判定する
        const session = await fetchAuthSession();
        const res = await executeQuery<GetPatientQuery>(getPatient, { id: session.userSub as string }, 'userPool');

        if (
          (await getIsMynumberAuth()) === '0' ||
          (await getIsMynumberAuth()) === 0 ||
          res?.getPatient?.isWalletCreate === null
        ) {
          console.log('マイナンバー認証基本情報必要');
          await gettoken();
          await getUserInfo();
        }
        if (redirectPath !== null) {
          await cookie.removeItem('mynumber_redirect_path');
          navigate(redirectPath);
          return;
        }
        if (!walletFlag) {
          await getWallet();
          walletFlag = true;
        }
      } catch (error) {
        // TODO
        console.log('データの更新に失敗しました。');
        console.error(error);
        setNotFetch(true);
      } finally {
        setIsLoading(false);
      }
    }, 1000);
    return () => clearTimeout(onetime);
  }, []);

  const handleClick = async () => {
    await getInterview();
  };

  if (notFetch === true) return <NotFound />;

  return (
    <>
      <Box sx={{ whiteSpace: 'nowrap' }}>
        <AppHeader title={'マイナンバー本人認証'} />
      </Box>
      {isLoading === false ? (
        <Grid sx={{ pt: 7 }}>
          <Typography textAlign={'center'} fontWeight={'bold'}>
            本人確認が完了しました
          </Typography>
          <Grid sx={{ textAlign: 'center', pt: 3, pb: 3 }}>
            <Typography fontSize={'0.9rem'}>
              事前問診がある場合は
              <br />
              次へお進みください
            </Typography>
          </Grid>
          <Grid sx={{ pt: 2, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <button
              onClick={handleClick}
              style={{ width: '353px', height: '48px', color: '#FFFFFF', textAlign: 'center', margin: 'auto' }}
              className="bg-primary flex relative rounded"
            >
              <div className="text-base m-auto font-normal" style={{ whiteSpace: 'pre-wrap' }}>
                次へ進む
              </div>
            </button>
          </Grid>
        </Grid>
      ) : (
        <LongLoading></LongLoading>
      )}
    </>
  );
};
